import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  deleteHolidayResponderFailure,
  deleteHolidayResponderSuccess,
} from "../slices/features/holidayResponder";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* deleteHolidaySaga(action: any) {
  const { payload } = action;
  const { id } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);
    const response: AxiosResponse<any> = yield call(
      appservice.deleteHolidayResponder,
      baseUrl,
      id
    );
    yield put(deleteHolidayResponderSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess();
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(deleteHolidayResponderFailure({ statusCode, statusText }));
  }
}

export function* watchDeleteHolidayResponder() {
  yield takeLatest(
    RequestTypes.DELETE_HOLIDAY_AUTORESPONDER,
    deleteHolidaySaga
  );
}
